module.exports = __webpack_public_path__ + "static/media/strikethrough.e847dca1.svg";